export const isFormFieldValid = (formik: any, name: string) =>
 !!(formik.touched[name] && formik.errors[name]);
